import { render, staticRenderFns } from "./learning-time.vue?vue&type=template&id=35a71256&scoped=true"
import script from "./learning-time.vue?vue&type=script&lang=js"
export * from "./learning-time.vue?vue&type=script&lang=js"
import style0 from "./learning-time.vue?vue&type=style&index=0&id=35a71256&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a71256",
  null
  
)

export default component.exports